"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Loading = ({ color = 'primary', size = 3, inline }) => {
    // Honouring the legacy "inline" prop that used to exist on this component.
    const _size = inline ? Math.min(2, size) : size;
    return (react_1.default.createElement("div", { className: inline ? 'd-inline-block p-1' : 'd-flex justify-content-center p-1' },
        react_1.default.createElement("div", { className: `spinner-border text-${color} ${inline ? 'spinner-border-sm' : ''}`, role: "status", style: { width: `${_size}rem`, height: `${_size}rem` } },
            react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))));
};
exports.default = Loading;
